<template>
    <div class="relative transition items-center inline-block">

          <div v-show="isHidden">
            <p>
              {{content}}<a v-on:click="isHidden = !isHidden" :class="['align-middle cursor-pointer', buttonsize]"><i :class="['material-icons align-middle mx-1', buttonsize]">{{buttonicon}}</i>{{buttonname}}</a>
            </p>
          </div>
          <div v-if="!isHidden" class="dropdown flex w-56 transition items-center">
              
              <div class="flex-1 pr-1 w-10/12">
                <v-select
                  :options="options"
                  label="name"
                  v-model="selected"
                  :placeholder="placeholder"
                  class="text-xs leading-normal"
                  >
                  </v-select>
              </div>
              <div class="w-2/12" v-show="isSure">
                  <a v-if="selected" v-on:click="isSure = !isSure" class="commitbutton p-0 inline-block"><i aria-hidden="true" class="material-icons align-middle text-3xl">check</i></a>
              </div>
          </div>
          <div v-if="!isSure" class="bg-red-600 text-white w-full p-3 absolute top-0 text-sm z-50" v-click-outside="onClickOutside">
              {{confirmtext}} <br>
              <button v-on:click="putItem" type="submit" class="btn text-sm bg-white text-red-700 commitbutton mt-1 rounded px-3 py-1"><i aria-hidden="true" class="material-icons align-middle text-3xl">check</i>Yes, Do It</button>
          </div>
        
      </div>
</template>

<script>
import VueSelect from 'vue-select';
import vClickOutside from 'v-click-outside'
import axios from 'axios'

  export default {
        
        components: { VueSelect },

        props: {
            options: '',
            placeholder: {
                default: 'Select Item' 
            },
            route:'',
            idname:'',
            content: '',
            route:'',
            routeparam:'',
            buttonname: {
              default: 'Change',
            },
            buttonicon: {
              default: 'edit',
            },
            buttonsize: {
              default: 'text-xs',
            },
            confirmtext: {
              default: 'Are You Sure?',
            }
        },

        data() {
          return {
            isHidden: true,
            isSure: true,
            success: false,
            loaded: true,
            name: '',
            selected: '',
          }
        },
        
        directives: {
          clickOutside: vClickOutside.directive
        },
        
        methods: {
          onClickOutside (event) {
              this.isSure = !this.isSure
          },

          formfocus() {
              document.getElementById("groupName").focus();
          },
          mounted(){
            this.formfocus()
          },

          putItem: function (event) {
            if (this.loaded) {
              this.loaded = false;
              this.success = false;
              $( ".commitbutton").addClass( "loading" );
              axios.put(
                  this.route,{ [this.routeparam]: this.selected.value }
                ).then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            };
          }

        },
      }
</script>
